export class StringUtils {
	static toTitleCase(text: string): string {
		if (!text) { return ''; }
		return text.toLowerCase().replace(/(?:^|\s)\S/g, char => char.toUpperCase());
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/utils/string-utils.ts